import React from 'react';
import { AwardIcon, CheckIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { checkoutUrl, included, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
export function PricingSection() {
  return <section id="pricing" className="scroll-mt-4 bg-mist energy-glow-light py-16 sm:py-24" aria-labelledby="pricing-title" data-id="element-160" data-mp="1j9gwqm2xz77s">
      <div className="mx-auto max-w-3xl px-4" data-id="element-161" data-mp="1n9ir0a6ckyd1">
        <h2 id="pricing-title" className="text-center text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-162" data-mp="1ncwph7bw4nf7">
          Choose your option
        </h2>

        <article className="mt-10 overflow-hidden rounded-2xl border border-line bg-white shadow-lift" data-id="element-163" data-mp="1x9rpjuntavvl">
          <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-164" data-mp="226rw06okq0n8" />
          <div className="p-6 sm:p-10" data-id="element-165" data-mp="2uyxu6q1up8x">
            <span className="inline-flex items-center gap-2 rounded-md bg-navy px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[.16em] text-greenGlow" data-id="element-166" data-mp="2w9y3wkadeva">
              <AwardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-167" data-mp="1mh6kz0e5945z" /> Main offer
            </span>

            <div className="mt-5 flex flex-col gap-6 border-b border-line pb-7 sm:flex-row sm:items-end sm:justify-between" data-id="element-168" data-mp="1hpg389cvne4j">
              <div data-id="element-169" data-mp="1crmyzlv4wu6w">
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-170" data-mp="1cr4szxio71ls">{productName}</h3>
                <p className="mt-2 text-sm text-muted" data-id="element-171" data-mp="17pxnk5402eia">
                  All {totalVolumes} volumes + {totalBonuses} strategic bonuses ready to use in your classroom.
                </p>
              </div>
              <div className="sm:text-right" data-id="element-172" data-mp="1vhcte7uzjdya">
                <span className="text-sm text-muted" data-id="element-173" data-mp="1vg1q095gc87p">
                  Regular price <span className="line-through" data-id="element-174" data-mp="1rgartkdlipt5">{priceBefore}</span>
                </span>
                <p className="mt-1 font-display text-5xl font-extrabold text-navy" data-id="element-175" data-mp="k1xyd9mc6w5t">{price}</p>
                <p className="text-xs font-extrabold uppercase tracking-[.16em] text-greenDark" data-id="element-176" data-mp="g0m76znte2vi">
                  Today · 50% discount
                </p>
              </div>
            </div>

            <ul className="mt-7 grid gap-2.5 sm:grid-cols-2" data-id="element-177" data-mp="mgundo0fhlgv">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-ink" data-id="element-178" data-mp="7jlsikbx1zke">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green" aria-hidden="true" data-id="element-179" data-mp="ciom98mg4jd2" />
                  {item}
                </li>)}
            </ul>

            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-9 w-full" data-id="element-180" data-mp="3uul4is7pvrgj">
              Get my collection now
            </Button>

            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-181" data-mp="3kzt65m6b90kp">
              <span className="inline-flex items-center gap-1.5" data-id="element-182" data-mp="3pxuq09bk93x8">
                <LockIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-183" data-mp="3bxk13btt9zep" /> Secure payment
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-184" data-mp="3fy3uq5f6ekw3">
                <ZapIcon className="h-4 w-4 text-navy" aria-hidden="true" data-id="element-185" data-mp="2xatq1iqacsfx" /> Instant access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-186" data-mp="2scs3uoxkcd08">
                <ShieldCheckIcon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-187" data-mp="2secvo6shthue" /> 7-day guarantee
              </span>
            </div>
            <p className="mt-4 text-center text-xs text-muted" data-id="element-188" data-mp="31cf437ek3crp">
              You pay in USD. Your payment platform automatically shows the conversion to your local currency.
            </p>
          </div>
        </article>
      </div>
    </section>;
}